import * as React from 'react';
import { Component } from 'react';
import './MessageSettingsForm.css';
import { GeneralMessagesSettingFormPriorities } from './GeneralMessagesSettingFormPriorities';
import { ParentsDeliverySettings } from '../../models/generalMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faGraduationCap, faSchool, faUserShield, faUsers } from '@fortawesome/free-solid-svg-icons';

interface Props {
  messageTitle: string;
  messageDescription: string;

  isSendStudents?: boolean;
  isSendParents?: boolean;
  isSendStaff?: boolean;
  isSendGovernors?: boolean;

  onTitleChange: (event) => void;
  onDescriptionChange: (event) => void;
  onIsSendParentsChange?: (event) => void;
  onIsSendStudentsChange?: (event) => void;
  onSendStaffChange?: (event) => void;
  onSendGovernorsChange?: (event) => void;
  onDeliverySettingsChanged?: (settings: ParentsDeliverySettings) => void;
  parentsDeliverySettings?: ParentsDeliverySettings;
  isRecipientsReadOnly?: boolean;
  displaySendStudents?: boolean;
  displaySendParents?: boolean;
  displaySendStaff?: boolean;
  displaySendGovernors?: boolean;
  hideParentDeliverySettings?: boolean;
  helpControl?: React.ReactNode;
}

export class GeneralMessageSettingsForm extends Component<Props> {
  renderAudienceOption(
    id: string,
    title: string,
    checked: boolean,
    onChange: (event) => void,
    icon: any,
    readOnly: boolean
  ) {
    return (
      <label
        className={`gmSettings__audience ${checked ? 'gmSettings__audience--active' : ''} ${
          readOnly ? 'gmSettings__audience--readonly' : ''
        }`}
        htmlFor={id}
      >
        <input id={id} type="checkbox" checked={checked} onChange={onChange} disabled={readOnly} />
        <span className="gmSettings__audienceIcon">
          <FontAwesomeIcon icon={icon} />
        </span>
        <span className="gmSettings__audienceCopy">
          <strong>{title}</strong>
        </span>
        <span className="gmSettings__audienceCheck">
          <FontAwesomeIcon icon={faCheck} />
        </span>
      </label>
    );
  }

  render() {
    const {
      messageTitle,
      messageDescription,
      isSendStudents,
      isSendParents,
      isSendStaff,
      isSendGovernors,
      onTitleChange,
      onDescriptionChange,
      onIsSendParentsChange,
      onIsSendStudentsChange,
      onSendStaffChange,
      onSendGovernorsChange,
      onDeliverySettingsChanged,
      parentsDeliverySettings,
      isRecipientsReadOnly = false,
      displaySendStudents,
      displaySendParents,
      displaySendStaff,
      displaySendGovernors,
      hideParentDeliverySettings = false,
      helpControl
    } = this.props;

    const shownSendStudents = typeof displaySendStudents === 'boolean' ? displaySendStudents : isSendStudents;
    const shownSendParents = typeof displaySendParents === 'boolean' ? displaySendParents : isSendParents;
    const shownSendStaff = typeof displaySendStaff === 'boolean' ? displaySendStaff : isSendStaff;
    const shownSendGovernors = typeof displaySendGovernors === 'boolean' ? displaySendGovernors : isSendGovernors;

    return (
      <div className="gmSettings">
        <div className="gmSettings__grid">
          <div className="gmField">
            <label className="gmField__label" htmlFor="gmMessageTitle">
              Title
            </label>
            <input
              id="gmMessageTitle"
              type="text"
              className="gmInput"
              placeholder="Internal title"
              onChange={onTitleChange}
              value={messageTitle}
            />
          </div>
          <div className="gmField">
            <label className="gmField__label" htmlFor="gmMessageDescription">
              Description
            </label>
            <input
              id="gmMessageDescription"
              type="text"
              className="gmInput"
              placeholder="Internal description"
              onChange={onDescriptionChange}
              value={messageDescription}
            />
          </div>
          {helpControl && <div className="gmSettings__help">{helpControl}</div>}
        </div>

        <section className="gmSettings__section">
          <div className="gmSettings__sectionHead">
            <h4>Recipients</h4>
          </div>
          <div className="gmSettings__audienceGrid">
            {typeof isSendParents !== 'undefined' &&
              this.renderAudienceOption(
                'messageSettingsFormIsSendParents',
                'Parents',
                shownSendParents,
                onIsSendParentsChange,
                faUsers,
                isRecipientsReadOnly
              )}
            {typeof isSendStudents !== 'undefined' &&
              this.renderAudienceOption(
                'messageSettingsFormIsSendStudents',
                'Students',
                shownSendStudents,
                onIsSendStudentsChange,
                faGraduationCap,
                isRecipientsReadOnly
              )}
            {typeof isSendStaff !== 'undefined' &&
              this.renderAudienceOption(
                'messageSettingsFormIsSendStaff',
                'School staff',
                shownSendStaff,
                onSendStaffChange,
                faSchool,
                isRecipientsReadOnly
              )}
            {typeof isSendGovernors !== 'undefined' &&
              this.renderAudienceOption(
                'messageSettingsFormIsSendGovernors',
                'Trustees / governors',
                shownSendGovernors,
                onSendGovernorsChange,
                faUserShield,
                isRecipientsReadOnly
              )}
          </div>
        </section>

        {typeof isSendParents !== 'undefined' && !hideParentDeliverySettings && (
          <GeneralMessagesSettingFormPriorities
            parentsDeliverySettings={parentsDeliverySettings}
            onDeliverySettingsChanged={onDeliverySettingsChanged}
            disabled={!isSendParents}
          />
        )}
      </div>
    );
  }
}
